import React, { FunctionComponent, MouseEvent } from "react";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Content } from "@iventis/translations";
import { InteractiveElement } from "@iventis/styles/src/components/interactive-elements";
import { iconButtonSize } from "@iventis/styles/src/atomic-rules";
import { SimpleTooltip } from "@iventis/components/src/tooltips";
import styled from "@emotion/styled";
import { DisabledOverlay } from "@iventis/components/src/disabled-overlay";

export interface LockIconProps {
    locked: boolean;
    onClick: (event: MouseEvent<HTMLElement>) => void;
    onMouseOver: boolean;
    isEditingNode: boolean;
    dataTestId?: string;
}

export const LockIconComponent: FunctionComponent<LockIconProps> = ({ locked, isEditingNode, onClick, onMouseOver, dataTestId }) => {
    const translate = useIventisTranslate();

    const toolTipText = locked
        ? Content.map9.layerOptionsTooltips.unlock_layer
        : isEditingNode
        ? Content.map9.layerOptionsTooltips.cannot_lock_layer_while_editing
        : Content.map9.layerOptionsTooltips.lock_layer;

    const disabled = isEditingNode;

    return (
        <SimpleTooltip text={translate(toolTipText)} placement="bottom" disabled={!onMouseOver}>
            <span>
                <StyledLockButton className={`node-segment icon lock ${disabled && "disabled"}`} onClick={onClick} disabled={disabled} data-testid={dataTestId}>
                    {disabled && <DisabledOverlay opacity={0} />}
                    {locked ? (
                        <span className="hidden">{translate(Content.map9.layerOptionsTooltips.unlock_layer)}</span>
                    ) : (
                        <span className="hidden">{translate(Content.map9.layerOptionsTooltips.lock_layer)}</span>
                    )}
                    <FontAwesomeIcon icon={["fas", locked ? "lock" : "lock-open"]} />
                </StyledLockButton>
            </span>
        </SimpleTooltip>
    );
};

const StyledLockButton = styled(InteractiveElement)`
    height: ${iconButtonSize};
    width: ${iconButtonSize};
    z-index: 100;
`;
